import React from 'react'
import classNames from 'classnames'
import i18n from '../../../../lib/i18n'
import { BLANK, splitVariants } from '../../../QuestionsLearning/questionTypes'
import { blankCorrect } from '../../grading'
import own from './AnswerBlanks.module.scss'

// type5: sentence with inline inputs in place of ___
function AnswerBlanks({ question, draft, onChange, checked, onSubmit }) {
  const parts = String(question.answers?.value || '').split(BLANK)
  const variants = question.answers?.variants || []

  const setBlank = (index, value) => {
    const next = [...draft]
    next[index] = value
    onChange(next)
  }

  return (
    <div className={own.sentence}>
      {parts.map((part, index) => {
        const isLast = index === parts.length - 1
        const value = draft[index] || ''
        const correct = checked && blankCorrect(question, draft, index)
        return (
          <React.Fragment key={index}>
            {part}
            {!isLast && (
              <span className={own.blankWrap}>
                <input
                  className={classNames(own.blank, { [own.correct]: correct, [own.wrong]: checked && !correct })}
                  // Grows with the text: dynamic width is the one inline style here
                  style={{ width: `${Math.max(6, value.length + 2)}ch` }}
                  value={value}
                  disabled={checked}
                  aria-label={`${i18n('qv_blank')} ${index + 1}`}
                  autoCapitalize="off"
                  autoComplete="off"
                  onChange={(e) => setBlank(index, e.target.value)}
                  onKeyDown={(e) => { if (e.key === 'Enter') onSubmit() }}
                />
                {checked && !correct && (
                  <span className={own.fix}>{splitVariants(variants[index]).join(' / ')}</span>
                )}
              </span>
            )}
          </React.Fragment>
        )
      })}
    </div>
  )
}

export default AnswerBlanks
